/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2025 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2025 - Finnish Meteorological Institute (FMI)
 * Copyright 2025 - The Norwegian Meteorological Institute (MET Norway)
 * */

// Define pressure [hPa] and temperature [°C] values for static lines
export const maxPressure = 1050;
export const minPressure = 150;
export const staticPressureArray = [maxPressure];
export const dp = -5;
export const minEmagramTemperature = -80;
export const minTemperature = -40;
export const maxTemperature = 40.6;

let pressure = maxPressure;
while (pressure > minPressure) {
  pressure += dp;
  staticPressureArray.push(pressure);
}

// Bijvoet constants
export const T_KAPPA = 0.2857;
export const T_KTHETA = 332.0;
export const KELVIN = 273.156;

export const WV_CA = 17.56881;
export const WV_CB = 241.8945;
export const WV_CE = 610.7;
export const EPSILON = 0.622;
export const R_AIR = 287.04;
export const HEATCP = 1005;

export const REFERENCE_PRESSURE = 1000 * 100; // 1000hPa = 100000Pa

export const EARTH_MEAN_RADIUS = 6371; // [km]
export const MAX_PROXIMITY_RADIUS = 100; // [km]
export const SAME_POINT_DISTANCE_KM = 0.05;
